import React, { Component } from 'react';
import { db } from '../firebase/Firebase';
import ReactToPrint from "react-to-print";
import { flattenDoc } from '../Util';
import ColType from '../Types';
import { Collapse, notification, Button, Icon, Popconfirm } from 'antd';
import Empty from '../customcomponents/Empty';
import moment from 'moment';
import ProfessionalLearningReportForm from './ProfessionalLearningReportForm';
import ProfessionalLearningReportUpdateForm from './ProfessionalLearningReportUpdateForm';

const { Panel } = Collapse;

var html2pdf = null
if (typeof window !== 'undefined') {
    html2pdf = require('html2pdf.js')
}

const successMessage = (description) => {
    notification.open({
        type: 'success',
        message: description,
        placement: 'bottomRight'
    });
};

const errorMessage = (description) => {
    notification.open({
        type: 'error',
        message: description,
        placement: 'bottomRight'
    });
};

class ProfessionalLearningReport extends Component {
    state = {
        reports: [],
        reportsMounted: false,
        reportsListener: null,
    };

    componentDidMount() {
        let reportsListener = db.collection(ColType.professionalLearningReport)
            .where('districtId', '==', this.props.districtId)
            .where('schoolId', '==', this.props.schoolId)
            .where('timeStamp', '>=', new Date('2026-07-01T00:00:00Z'))
            .orderBy('timeStamp', 'desc')
            .limit(50)
            .onSnapshot((querySnapshot) => {
                let reports = [];
                querySnapshot.forEach((doc) => {
                    reports.push(flattenDoc(doc));
                });
                this.setState({
                    reports: reports,
                    reportsMounted: true
                });
            });

        this.setState({
            reportsListener: reportsListener
        });
    }

    componentWillUnmount() {
        if (this.state.reportsListener) {
            this.state.reportsListener();
        }
    }

    // Header label for a report row. Older reports may still have a title,
    // newer ones are labeled by the date they were created.
    getReportLabel = (report) => {
        if (report.title) {
            return report.title
        }
        return report.timeStamp ?
            'Goals from ' + moment.utc(report.timeStamp.seconds * 1000).format("MMM DD, YYYY") :
            'School improvement goals'
    }

    getFileName = (report) => {
        let datePart = report.timeStamp ?
            moment.utc(report.timeStamp.seconds * 1000).format("MM-DD-YYYY") :
            'current'
        return `School-Improvement-Goals-${datePart}.pdf`
    }

    render() {
        return (
            <div className="professional-learning-container">
                <div className="header-section">
                    <div className="header-copy">
                        <h1 className="page-title">Our School Improvement Reports</h1>
                        <div className="page-subtitle">The goals your school is working toward, and how each role supports them.</div>
                    </div>
                    <ProfessionalLearningReportForm
                        districtId={this.props.districtId}
                        schoolId={this.props.schoolId}
                        personId={this.props.personId}
                    />
                </div>

                <div className="callout">
                    <Icon type='flag' className="callout-icon" />
                    <div>
                        <div className="callout-title">Add the goals from your school improvement report</div>
                        <div className="callout-text">Write the goals once, then add reflections as the year goes on. Open a goal set to edit, print, or download it.</div>
                    </div>
                </div>

                <div className="reports-section">
                    {this.state.reportsMounted ?
                        this.state.reports.length === 0 ?
                            <Empty
                                containerClassName="empty-state"
                                width={55}
                                height={55}
                                image={'/empty/goals.png'}
                                description={'No school improvement goals yet. Add your goals to get started.'}
                            />
                            :
                            <Collapse bordered={false} className="reports-collapse">
                                {this.state.reports.map((report) => {
                                    let contentRefName = 'content-' + report.id;
                                    return (
                                        <Panel
                                            header={
                                                <div className="report-header">
                                                    <div className="report-title">
                                                        <span className="plan-title">{this.getReportLabel(report)}</span>
                                                    </div>
                                                    <div className="report-date">
                                                        {report.timeStamp ? moment.utc(report.timeStamp.seconds * 1000).format("MMM DD, YYYY") : ''}
                                                    </div>
                                                </div>
                                            }
                                            key={report.id}
                                            className="report-panel"
                                        >
                                            <div className="report-content">
                                                <div className="action-buttons">
                                                    <ProfessionalLearningReportUpdateForm
                                                        districtId={this.props.districtId}
                                                        schoolId={this.props.schoolId}
                                                        report={report}
                                                    />
                                                    <ReactToPrint
                                                        trigger={() =>
                                                            <Button type="default" size='large'>
                                                                <Icon type="download" /> Download PDF
                                                            </Button>
                                                        }
                                                        content={() => this[contentRefName]}
                                                        print={async (printIframe) => {
                                                            if (!html2pdf) {
                                                                return new Promise((resolve, reject) => { resolve() })
                                                            }
                                                            const document = printIframe.contentDocument
                                                            if (document) {
                                                                const html = document.getElementsByTagName('html')[0]
                                                                await html2pdf().from(html).set({
                                                                    image: { type: 'png', quality: 1.0 },
                                                                    html2canvas: { scale: 1.0 },
                                                                    margin: 12,
                                                                    pagebreak: { mode: ['avoid-all', 'css'] },
                                                                }).save(this.getFileName(report))
                                                            }
                                                            return new Promise((resolve, reject) => { resolve() })
                                                        }}
                                                    />
                                                    <ReactToPrint
                                                        trigger={() => (
                                                            <Button type="default" size='large'>
                                                                <Icon type="printer" /> Print
                                                            </Button>
                                                        )}
                                                        content={() => this[contentRefName]}
                                                    />
                                                    {this.props.personId === report.personId &&
                                                        <Popconfirm
                                                            title="Delete these goals?"
                                                            onConfirm={() => {
                                                                db.collection(ColType.professionalLearningReport)
                                                                    .doc(report.id)
                                                                    .delete()
                                                                    .then(() => {
                                                                        successMessage('Goals deleted.');
                                                                    })
                                                                    .catch((error) => {
                                                                        console.log(error);
                                                                        errorMessage('Error deleting goals. Please try again.');
                                                                    });
                                                            }}
                                                            okText="Delete"
                                                            cancelText="Cancel"
                                                        >
                                                            <Button type="danger" className="delete-btn">
                                                                <Icon type="delete" />
                                                            </Button>
                                                        </Popconfirm>
                                                    }
                                                </div>

                                                <div ref={el => (this[contentRefName] = el)} className="printable-content">
                                                    <div className="report-document">
                                                        <div className="document-header">
                                                            <img src="/dotit-logo-color-new.png" alt="logo" className="logo" />
                                                            <h2>Our School Improvement Reports</h2>
                                                            <div className="plan-meta">
                                                                <div className="plan-details">
                                                                    <span>Created: {report.timeStamp ? moment.utc(report.timeStamp.seconds * 1000).format("MM/DD/YYYY") : ''}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="plan-overview">
                                                            <div className="section">
                                                                <div className="section-header">
                                                                    <h3>School Improvement Goals</h3>
                                                                </div>
                                                                <div className="section-content">
                                                                    {report.description}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="support-plan">
                                                            <div className="section">
                                                                <div className="section-header">
                                                                    <h3>Support Framework</h3>
                                                                    <p>How each role will contribute to success</p>
                                                                </div>
                                                                <div className="support-grid">
                                                                    <div className="support-role">
                                                                        <div className="role-header">
                                                                            <Icon type="user" className="role-icon admin" />
                                                                            <h4>Administration</h4>
                                                                        </div>
                                                                        <div className="role-content">
                                                                            {report.adminSupport}
                                                                        </div>
                                                                    </div>
                                                                    <div className="support-role">
                                                                        <div className="role-header">
                                                                            <Icon type="team" className="role-icon coach" />
                                                                            <h4>Coach</h4>
                                                                        </div>
                                                                        <div className="role-content">
                                                                            {report.coachSupport}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {(report.reflection1 || report.reflection2) &&
                                                            <div className="reflections-section">
                                                                <div className="section">
                                                                    <div className="section-header">
                                                                        <h3>Progress Reflections</h3>
                                                                        <p>Ongoing reflections and insights</p>
                                                                    </div>
                                                                    <div className="reflections-grid">
                                                                        {report.reflection1 &&
                                                                            <div className="reflection-item">
                                                                                <div className="reflection-header">
                                                                                    <h4>Reflection 1</h4>
                                                                                    {report.reflection1Date &&
                                                                                        <span className="reflection-date">
                                                                                            {moment.utc(report.reflection1Date.seconds * 1000).format("MMM DD, YYYY")}
                                                                                        </span>
                                                                                    }
                                                                                </div>
                                                                                <div className="reflection-content">
                                                                                    {report.reflection1}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {report.reflection2 &&
                                                                            <div className="reflection-item">
                                                                                <div className="reflection-header">
                                                                                    <h4>Reflection 2</h4>
                                                                                    {report.reflection2Date &&
                                                                                        <span className="reflection-date">
                                                                                            {moment.utc(report.reflection2Date.seconds * 1000).format("MMM DD, YYYY")}
                                                                                        </span>
                                                                                    }
                                                                                </div>
                                                                                <div className="reflection-content">
                                                                                    {report.reflection2}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }

                                                        {report.solutions &&
                                                            <div className="solutions-section">
                                                                <div className="section">
                                                                    <div className="section-header">
                                                                        <h3>Our Solutions</h3>
                                                                        <p>The solutions we are putting in place to reach these goals</p>
                                                                    </div>
                                                                    <div className="section-content">
                                                                        {report.solutions}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Panel>
                                    );
                                })}
                            </Collapse>
                        : <div className="loading">Loading goals...</div>}
                </div>

                <style jsx>{`
                    .professional-learning-container {
                        max-width: 1200px;
                        margin: 0 auto;
                        padding: 20px;
                    }
                    .header-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        gap: 24px;
                        margin-bottom: 22px;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #e8eef5;
                    }
                    .header-copy {
                        min-width: 0;
                    }
                    .page-title {
                        font-size: 32px;
                        font-weight: 800;
                        color: #1e293b;
                        margin: 0;
                        letter-spacing: -0.4px;
                    }
                    .page-subtitle {
                        font-size: 16px;
                        color: #475569;
                        margin-top: 4px;
                        line-height: 1.5;
                    }
                    .callout {
                        display: flex;
                        gap: 16px;
                        align-items: center;
                        background: #f0f7ff;
                        border: 1px solid #cfe3ff;
                        border-radius: 16px;
                        padding: 18px 22px;
                        margin-bottom: 22px;
                    }
                    .callout-icon {
                        font-size: 30px;
                        color: #1098f7;
                    }
                    .callout-title {
                        font-size: 20px;
                        font-weight: 800;
                        color: #1e293b;
                        margin-bottom: 2px;
                    }
                    .callout-text {
                        font-size: 16px;
                        color: #475569;
                        line-height: 1.5;
                    }
                    .reports-section {
                        margin-top: 20px;
                    }
                    .empty-state {
                        text-align: center;
                        padding: 60px 20px;
                        color: #475569;
                        background: #fff;
                        border: 1px solid #e8eef5;
                        border-radius: 16px;
                    }
                    .reports-collapse {
                        background: transparent;
                    }
                    :global(.reports-collapse .ant-collapse-item) {
                        margin-bottom: 12px;
                        background: #fff;
                        border: 1px solid #e8eef5 !important;
                        border-radius: 16px;
                        box-shadow: rgba(100, 100, 111, 0.12) 0px 4px 14px 0px;
                        overflow: hidden;
                    }
                    :global(.reports-collapse .ant-collapse-header) {
                        padding: 16px 20px 16px 44px !important;
                        color: #1e293b !important;
                    }
                    .report-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        padding: 2px 0;
                    }
                    .report-title {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex: 1;
                        min-width: 0;
                    }
                    .plan-title {
                        font-weight: 700;
                        color: #1e293b;
                        font-size: 18px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width: 520px;
                    }
                    .report-date {
                        color: #64748b;
                        font-size: 14px;
                        white-space: nowrap;
                    }
                    .report-content {
                        padding: 8px 12px 20px 12px;
                    }
                    .action-buttons {
                        display: flex;
                        gap: 10px;
                        margin-bottom: 24px;
                        justify-content: flex-end;
                    }
                    .delete-btn {
                        border-radius: 8px;
                        width: 40px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .printable-content {
                        background: white;
                        border: 1px solid #e8eef5;
                        border-radius: 16px;
                        padding: 30px;
                    }
                    .report-document {
                        max-width: 800px;
                        margin: 0 auto;
                        line-height: 1.6;
                    }
                    .document-header {
                        text-align: center;
                        margin-bottom: 40px;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #e8eef5;
                    }
                    .logo {
                        height: 70px;
                        margin-bottom: 20px;
                    }
                    .document-header h2 {
                        font-size: 28px;
                        font-weight: 800;
                        color: #1e293b;
                        margin: 0 0 16px 0;
                    }
                    .plan-meta {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }
                    .plan-details {
                        display: flex;
                        justify-content: center;
                        gap: 30px;
                        color: #64748b;
                        font-weight: 500;
                    }
                    .plan-overview {
                        margin-bottom: 40px;
                    }
                    .section {
                        margin-bottom: 30px;
                    }
                    .section-header h3 {
                        color: #1e293b;
                        font-size: 20px;
                        font-weight: 700;
                        margin: 0 0 5px 0;
                        border-left: 4px solid #1098f7;
                        padding-left: 15px;
                    }
                    .section-header p {
                        color: #64748b;
                        font-size: 14px;
                        margin: 0 0 15px 19px;
                    }
                    .section-content {
                        color: #334155;
                        font-size: 16px;
                        white-space: pre-wrap;
                        padding-left: 19px;
                    }
                    .support-plan {
                        margin-bottom: 40px;
                    }
                    .support-grid {
                        display: grid;
                        grid-template-columns: 1fr;
                        gap: 20px;
                        margin-top: 20px;
                    }
                    .support-role {
                        border: 1px solid #e8eef5;
                        border-radius: 16px;
                        padding: 20px;
                        background: #f8fafc;
                    }
                    .role-header {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 12px;
                    }
                    .role-icon {
                        font-size: 18px;
                        padding: 8px;
                        border-radius: 50%;
                        color: white;
                    }
                    .role-icon.admin {
                        background: #1e3a5f;
                    }
                    .role-icon.coach {
                        background: #1098f7;
                    }
                    .role-header h4 {
                        margin: 0;
                        color: #1e293b;
                        font-size: 16px;
                        font-weight: 700;
                    }
                    .role-content {
                        color: #334155;
                        font-size: 15px;
                        white-space: pre-wrap;
                        line-height: 1.5;
                    }
                    .reflections-section {
                        border-top: 1px solid #e8eef5;
                        padding-top: 30px;
                    }
                    .reflections-grid {
                        display: grid;
                        grid-template-columns: 1fr;
                        gap: 20px;
                        margin-top: 20px;
                    }
                    .reflection-item {
                        border: 1px solid #cfe3ff;
                        border-radius: 16px;
                        padding: 20px;
                        background: #f0f7ff;
                    }
                    .reflection-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 12px;
                    }
                    .reflection-header h4 {
                        margin: 0;
                        color: #1e293b;
                        font-size: 16px;
                        font-weight: 700;
                    }
                    .reflection-date {
                        color: #64748b;
                        font-size: 14px;
                        font-weight: 500;
                    }
                    .reflection-content {
                        color: #334155;
                        font-size: 15px;
                        white-space: pre-wrap;
                        line-height: 1.5;
                    }
                    .solutions-section {
                        border-top: 1px solid #e8eef5;
                        padding-top: 30px;
                    }
                    .loading {
                        text-align: center;
                        padding: 40px;
                        color: #64748b;
                    }
                    @media (max-width: 768px) {
                        .header-section {
                            flex-direction: column;
                            gap: 16px;
                            align-items: flex-start;
                        }
                        .report-header {
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 6px;
                        }
                        .plan-title {
                            max-width: 100%;
                        }
                        .plan-details {
                            flex-direction: column;
                            gap: 10px;
                        }
                        .action-buttons {
                            flex-wrap: wrap;
                            justify-content: flex-start;
                        }
                        .support-grid, .reflections-grid {
                            grid-template-columns: 1fr;
                        }
                    }
                    @media (min-width: 769px) {
                        .support-grid {
                            grid-template-columns: 1fr 1fr;
                        }
                        .reflections-grid {
                            grid-template-columns: 1fr 1fr;
                        }
                    }
                `}</style>
            </div>
        );
    }
}

export default ProfessionalLearningReport;